import { combineReducers } from 'redux';
import kitColeta from './slices/kitColeta.slice';

const reducer = combineReducers({
  kitColeta
})

export default reducer;
